import React from "react";
import { useActiveLeague } from "../hooks/useActiveLeague";

/**
 * React hook that returns a memoised league path prefix (e.g. "/premier").
 * Falls back to an empty string when no active league exists yet.
 */
export const useLeaguePrefix = () => {
  const { activeLeague } = useActiveLeague();
  return React.useMemo(() => (activeLeague?.slug ? `/${activeLeague.slug}` : ""), [activeLeague]);
};

/**
 * Build a link to a league table.
 * @param {string} leagueSlug league URL slug
 */
export const buildLeagueTableLink = (leagueSlug) => (
  leagueSlug ? `/${leagueSlug}/table` : "/onboarding"
);

/**
 * Build a link to the Team Pitch page.
 * @param {string|number} teamId mongodb / numeric id
 * @param {string} prefix optional pre-computed prefix to avoid extra hook reads
 */
export const buildTeamLink = (teamId, prefix = "") => `${prefix}/team-pitch/${teamId}`;

/**
 * Build a link to the Public Team View page.
 * @param {string|number} teamId mongodb / numeric id
 * @param {string} prefix optional pre-computed prefix to avoid extra hook reads
 */
export const buildPublicTeamLink = (teamId, prefix = "") => `${prefix}/team/${teamId}`;

/**
 * Build a link to a Match sub-page (match, summary, lineups).
 * @param {string|number} matchId
 * @param {string} suffix "match" | "summary/TEAM_ID" | "lineups"
 * @param {string} prefix optional league prefix
 */
export const buildMatchLink = (matchId, suffix = "match", prefix = "") =>
  `${prefix}/match/${matchId}/${suffix}`;
